import axios from 'axios';
import store from '../store/index';

let waitingForToken = false;
let logoutConfirmIsVisible = false;
let sessionHasExpired = false;

function showLogoutConfirm() {
	bootbox.confirm({
		title: "Your Session Has Expired",
		message: "Do you want to continue to the login screen?",
		buttons: {
				cancel: {
					label: '<i class="fa fa-times"></i> Cancel'
				},
				confirm: {
					label: '<i class="fa fa-check"></i> Go To Login Screen'
				}
		},
		callback: function(result) {
			if(result) {
				store.commit('updateAccessToken', '');
				window.location = '/CommunityWebPortal/_auth'
			} else {
				logoutConfirmIsVisible = false;
			}
		}
	});
}

/**
 * Set the default base url for every request. If an absolute path url is given then the default will be overridden
 */
let defaultBaseUrl = window.location.protocol+"//"+window.location.host;
if (!window.location.port) {}
else if (window.location.protocol=="http:" && window.location.port==80) {}
else if (window.location.protocol=="https:" && window.location.port==443) {}
else {
	defaultBaseUrl = defaultBaseUrl + ":"+window.location.port;
}
defaultBaseUrl += '/PortalAPI/index.cfm/api/';

axios.create({
	baseURL: defaultBaseUrl,
});


/**
 * Attaches the access token, client id, and some other data to every api request.
 */
axios.interceptors.request.use(function(config) {
	config.baseURL = defaultBaseUrl;

	if(store.state.role === 'admin') {
		config.params.role_code = store.state.adminRole;
	}
	
	config.headers = {
		"Authorization": `bearer ${store.state.accessToken}`,
		"Client-ID": store.state.clientID,
		"requestPath": store.state.route.path,
		"browserId": store.state.browserId,
		"requestUrl": !!config.url ? config.url : '',
		"locationHref": location.href,
		"userId": !!store.state.profile ? store.state.profile.USER_ID : '',
		"userGuid": !!store.state.profile ? store.state.profile.USER_GUID: '',
		"studentRid": store.state.selectedStudentRID,
		"errorStack": new Error().stack.toString().replace("\n"," "),
		"first_started": store.state.sessionItems.first_started,
		"servername": store.state.sessionItems.servername,
		"sessionId": store.state.sessionItems.sessionId,
		"started": store.state.sessionItems.started,
	}
	
	//if(!!config.url && config.url.indexOf('class-pages//') > -1){
		/* If we lost out courseSection guid reroute back to home */
		//window.location = '/CommunityWebPortal/_app/';
		//return;
	//}

	return config;
}, function(error) {
	const status = error.response ? error.response.status : null
	// Do something with request error
	if(status === 500) {
		store.commit('setError', true);
	}
	return Promise.reject(error);
});

/**
 * This axios response interceptor handles a request that uses an invalid token.
 * When an invalid token is used a response 401 is sent back from api. The inteceptor makes a request for a
 * new token and retries the request. If the session on auth server is expired and a new token can't be
 * provided the user is presented with a confirm box to go to login screen or stay on current screen. 
 * This axios response interceptor also handles displaying toast messages
 * the interceptor looks at the messages array and creates toasts messages 
 * for success, warning, danger, and info. Any 400, 500 errors are also caught 
 * and a danger alert is created
 */
axios.interceptors.response.use(response => {
	
	return response;
},
error => {
	const status = error.response ? error.response.status : null

	if (status === 401) {
		if( !sessionHasExpired ){
			let TokenPromise = store.dispatch('fetchToken');
			return TokenPromise.then(response => {
				error.config.headers['Authorization'] = 'bearer ' + store.state.accessToken;
				return axios.request(error.config);
			}).catch( response => {
				sessionHasExpired = true;
			});
		}
	}

	if(status === 500) {
		store.commit('setError', true);
	}

	return Promise.reject(error);
});
